import { RouteObject } from 'react-router-dom';
import { AdminLayout } from './layouts/AdminLayout';
import { AdminViewOnly } from '../Views/Admin/AdminViewOnly';
import UserUploadedTemplates from '../Views/Admin/UserUploadedTemplates';
import GenerateNoteForUser from '../Views/Admin/GenerateNoteForUser';
import CohortDefinitionsView from '../Views/Admin/CohortDefinitionsView';
import AnalysisSessionInspector from '../Views/Admin/AnalysisSessionInspector';
import { FeedbackOverview } from '../Views/Admin/FeedbackOverview';
import AdminFeedbackSessionView from '../Views/Admin/AdminFeedbackSessionView';
import { AdminFeedbackSessionLoader } from '../loaders/AdminFeedbackSessionLoader';
import { NotesOverview } from '../Views/Admin/NotesOverview';
import AdminNoteView from '../Views/Admin/AdminNoteView';
import { AdminNoteLoader } from '../loaders/NoteLoader';
import { ModeratorView } from '../Views/Admin/ModeratorView';
import { SelectedUserProvider } from '../context/selectedUserContext.tsx';
import { SpecialtiesOverview } from '../Views/Admin/SpecialtiesOverview';
import { TemplatesOverview } from '../Views/Admin/TemplatesOverview';
import { BaseTemplatesOverview } from '../Views/Admin/BaseTemplatesOverview';
import { PublicTemplatesOverview } from '../Views/Admin/PublicTemplatesOverview';
import { UserTemplatesOverview } from '../Views/Admin/UserTemplatesOverview';
import { ModulesOverview } from '../Views/Admin/ModulesOverview';
import { TemplateEditor } from '../Views/Admin/TemplateEditor';
import { TemplateLoader } from '../loaders/TemplatesLoader';
import { BaseTemplateEditor } from '../Views/Admin/BaseTemplateEditor';
import { BaseTemplateLoader } from '../loaders/TemplatesLoader';
import { PublicTemplateEditor } from '../Views/Admin/PublicTemplateEditor';
import { PublicTemplateLoader } from '../loaders/TemplatesLoader';
import { SpecialtyEditor } from '../Views/Admin/SpecialtyEditor';
import { UserTemplateEditor } from '../Views/Admin/UserTemplateEditor';
import { UserTemplateLoader } from '../loaders/TemplatesLoader';
import { ModuleEditor } from '../Views/Admin/ModuleEditor';
import { ModuleLoader } from '../loaders/ModulesLoader';
import ConfigView from '../Views/Admin/ConfigView';
import ExtractionTestsView from '../Views/Admin/ExtractionTestsView';
import { AdminToolsView } from '../Views/Admin/AdminToolsView';
import NoteProcessingViewTests from '../Views/Admin/NoteProcessingTestsView';
import { GenerationSessionView } from '../Views/Admin/GenerationSessionView';
import { GenerationSessionModelComparisonView } from '../Views/Admin/GenerationSessionModelComparisonView';
import { ModuleCustomizationView } from '../Views/ModuleCustomizationView';
import AdminModulesPage from '../components/Admin/modules/AdminModulesPage';
import AdminTemplatesPage from '../components/Admin/templates/AdminTemplatesPage';
import { UserOverview } from '../Views/Admin/UsersOverview';

export const adminRoutes: RouteObject[] = [
  {
    path: '/admin/',
    element: <AdminLayout />,
    children: [
      {
        path: '/admin/users',
        element: (
          <ModeratorView>
            <SelectedUserProvider>
              <UserOverview />
            </SelectedUserProvider>
          </ModeratorView>
        ),
      },
      {
        path: '/admin/pdfuploads',
        element: (
          <AdminViewOnly>
            <UserUploadedTemplates />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/generateNoteForUser',
        element: (
          <AdminViewOnly>
            <GenerateNoteForUser />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/cohorts',
        element: (
          <AdminViewOnly>
            <CohortDefinitionsView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/analysis',
        element: (
          <AdminViewOnly>
            <AnalysisSessionInspector />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/feedbacks/:user_id?',
        element: (
          <AdminViewOnly>
            <FeedbackOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/feedback/:feedbackSessionId',
        element: (
          <AdminViewOnly>
            <AdminFeedbackSessionView />
          </AdminViewOnly>
        ),
        loader: AdminFeedbackSessionLoader,
      },
      {
        path: '/admin/notes/:user_id?',
        element: (
          <AdminViewOnly>
            <NotesOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/note/:noteId',
        element: (
          <AdminViewOnly>
            <AdminNoteView />
          </AdminViewOnly>
        ),
        loader: ({ params }) => {
          if (!params.noteId) {
            throw new Error('Note ID is required');
          }
          return AdminNoteLoader(params.noteId);
        },
      },
      {
        path: '/admin/specialties',
        element: (
          <AdminViewOnly>
            <SpecialtiesOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/templates',
        element: (
          <AdminViewOnly>
            <AdminTemplatesPage />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/basetemplates',
        element: (
          <AdminViewOnly>
            <BaseTemplatesOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/publictemplates',
        element: (
          <AdminViewOnly>
            <PublicTemplatesOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/usertemplates',
        element: (
          <AdminViewOnly>
            <UserTemplatesOverview />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/modules',
        element: (
          <AdminViewOnly>
            <AdminModulesPage />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/template/:templateId',
        element: (
          <AdminViewOnly>
            <TemplateEditor />
          </AdminViewOnly>
        ),
        loader: TemplateLoader,
      },
      {
        path: '/admin/basetemplate/:baseTemplateId',
        element: (
          <AdminViewOnly>
            <BaseTemplateEditor />
          </AdminViewOnly>
        ),
        loader: BaseTemplateLoader,
      },
      {
        path: '/admin/publictemplate/:templateId',
        element: (
          <AdminViewOnly>
            <PublicTemplateEditor />
          </AdminViewOnly>
        ),
        loader: PublicTemplateLoader,
      },
      {
        path: '/admin/specialty/:specialtyId',
        element: (
          <AdminViewOnly>
            <SpecialtyEditor />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/usertemplate/:templateId',
        element: (
          <AdminViewOnly>
            <UserTemplateEditor />
          </AdminViewOnly>
        ),
        loader: UserTemplateLoader,
      },
      {
        path: '/admin/module/:moduleId',
        element: (
          <AdminViewOnly>
            <ModuleEditor />
          </AdminViewOnly>
        ),
        loader: ModuleLoader,
      },
      {
        path: '/admin/config',
        element: (
          <AdminViewOnly>
            <ConfigView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/extractionTests',
        element: (
          <AdminViewOnly>
            <ExtractionTestsView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/tools/',
        element: (
          <AdminViewOnly>
            <AdminToolsView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/noteProcessingTests/',
        element: (
          <AdminViewOnly>
            <NoteProcessingViewTests />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/generation',
        element: (
          <AdminViewOnly>
            <GenerationSessionView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/generationComparison',
        element: (
          <AdminViewOnly>
            <GenerationSessionModelComparisonView />
          </AdminViewOnly>
        ),
      },
      {
        path: '/admin/moduleCustomization',
        element: (
          <AdminViewOnly>
            <ModuleCustomizationView />
          </AdminViewOnly>
        ),
      },
    ],
  },
];
